// extracted by mini-css-extract-plugin
export default {"chipArea":"Card_chipArea__Cg+hT","cardText":"Card_cardText__kl1p4","cardButton":"Card_cardButton__7iFUY"};